import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

type ProductAvailabilityState = Readonly<{
    isLoading: boolean;
}>;

const initialState: ProductAvailabilityState = {
    isLoading: false
};

const ProductAvailabilityData = createTypedReducerWithImmer(initialState, {
    "Custom/ProductAvailability/SetIsLoading": (
        draft: Draft<ProductAvailabilityState>, 
        action: { isLoading: boolean }
    ) => {
        draft.isLoading = action.isLoading;
    },
});

export default (reducers as any).xcentiumProductAvailability = ProductAvailabilityData;

export type CustomProductAvailabilityState = {
    xcentiumProductAvailability: ProductAvailabilityState;
} & ApplicationState;

type Reducers = {
    productAvailabilityReducer: typeof ProductAvailabilityData;
};

export type XCentiumProductAvailabilityActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
